import React, { useState, useMemo, useEffect } from 'react';
import { Form, Steps, Space, Modal, message, Select } from 'antd';
import styled from 'styled-components';
import InputReset from './reset/inputReset';
import SelectReset from './reset/selectReset';
import CascaderReset from './reset/CascaderReset';
import { ComponentEnum } from './form';
import formStore from 'store/form-submit';
import { useHistory } from 'react-router';
import { AxiosError } from 'axios';
import { phoneAreaCode } from '@/lib/locale';
import Upload from './reset/upload';
const { Step } = Steps;
const { Option } = Select;
interface IScopeItem {
  enName: string;
  localName: string;
  value: string;
}

const FormSteps = (props: any) => {
  const { steps = [] } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [current, setCurrent] = React.useState(0);
  const [email, setEmail] = useState('');
  const [PhoneCode, setPhoneCode] = useState(phoneAreaCode);
  const [form] = Form.useForm();
  const history = useHistory();
  const [formShow, setFormShow] = useState<boolean>(true);
  const changePhoneAreacode = (value: any) => {
    setPhoneCode(value);
  };

  const stepsData = [...steps];

  const formatStepsData = (currentNumber: number) => {
    if (Array.isArray(stepsData) && stepsData.length) {
      stepsData.forEach((item, index) => {
        if (Array.isArray(item.stepFieldConfigs) && item.stepFieldConfigs.length) {
          item.stepFieldConfigs = item.stepFieldConfigs.map((c: { required: any }) => {
            return {
              ...c,
              required: c.required && currentNumber === index,
            };
          });
        }
      });
    }
  };

  useEffect(() => {
    formatStepsData(current);
  }, []);

  // 监听current,格式化表单元数据
  useEffect(() => {
    formatStepsData(current);
  }, [current]);

  // 根据步骤，动态修改steps中每个formItem的required,仅保持当前step中需要required的item项为true
  const dynamicSteps = useMemo(() => {
    return stepsData.map((step: any) => ({
      title: props.defaultLang === 'EN' ? step.stepEnName : step.stepLocalName,
      content: step.stepFieldConfigs?.map((item: any, index: any) => (
        <>
          {item.componentType === ComponentEnum.INPUT && item.contentType !== ComponentEnum.FILE && (
            <Form.Item
              label=" "
              name={item.fieldCode}
              key={index}
              rules={[
                {
                  required: item.required,
                  validator: (_, value) => {
                    if (item.required) {
                      if (value) {
                        let validate = Promise.resolve();
                        item.validators?.forEach((self: any) => {
                          if (self.type === 'MINVALUE') {
                            if (Number(value) < Number(self.value)) {
                              validate = Promise.reject(props.defaultLang === 'EN' ? self.enError : self.localError);
                            }
                            return Promise.resolve();
                          }
                          if (self.type === 'MAXVALUE') {
                            if (Number(value) > Number(self.value)) {
                              validate = Promise.reject(props.defaultLang === 'EN' ? self.enError : self.localError);
                            }
                            return Promise.resolve();
                          }
                          if (self.type === 'MINLENGTH') {
                            value?.length < Number(self.value)
                              ? (validate = Promise.reject(props.defaultLang === 'EN' ? self.enError : self.localError))
                              : Promise.resolve();
                          }
                          if (self.type === 'MAXLENGTH') {
                            value?.length > Number(self.value)
                              ? (validate = Promise.reject(props.defaultLang === 'EN' ? self.enError : self.localError))
                              : Promise.resolve();
                          }
                          if (self.type === 'REGEX') {
                            const reg = new RegExp(self.value);

                            !reg.test(value)
                              ? (validate = Promise.reject(props.defaultLang === 'EN' ? self.enError : self.localError))
                              : (validate = Promise.resolve());
                          }
                        });
                        return validate;
                      } else {
                        return Promise.reject(`please input the ${item.fieldEnName}`);
                      }
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}>
              <InputReset
                defaultValue={
                  item.valueScopes
                    ? item.valueScopes?.map((self: IScopeItem) => {
                        if (item.defaultValue && self.value === item.defaultValue) {
                          return props.defaultLang === 'EN' ? self.enName : self.localName;
                        } else {
                          return item.defaultValue;
                        }
                      })
                    : item.defaultValue
                }
                type={item.contentType}
                inputValue={form.getFieldValue(`${item.fieldCode}`)}
                placeholder={props.defaultLang === 'EN' ? item.fieldEnName : item.fieldLocalName}
                remark={item.fieldEnPlaceholder}
              />
            </Form.Item>
          )}
          {item.componentType === ComponentEnum.DROP_LIST && (
            <Form.Item label=" " name={item.fieldCode} key={index} rules={[{ required: item.required }]}>
              <SelectReset
                defaultValue={item.valueScopes?.map((self: IScopeItem) => {
                  if (self.value === item.defaultValue) {
                    return props.defaultLang === 'EN' ? self.enName : self.localName;
                  }
                })}
                data={item.valueScopes ?? []}
                defaultLang={props.defaultLang}
                value={form.getFieldValue(`${item.fieldCode}`)}
                placeholder={props.defaultLang === 'EN' ? item.fieldEnName : item.fieldLocalName}
              />
            </Form.Item>
          )}
          {item.componentType === ComponentEnum.ADDRESS_CASCADE && (
            <Form.Item label=" " name={item.fieldCode} key={index} rules={[{ required: item.required }]}>
              <CascaderReset
                addressData={props.addressData}
                value={form.getFieldValue(`${item.fieldCode}`)}
                placeholder={props.defaultLang === 'EN' ? item.fieldEnName : item.fieldLocalName}
              />
            </Form.Item>
          )}
          {item.componentType === ComponentEnum.MOBILE_GLOBAL && (
            <Space>
              <Select
                bordered={false}
                onChange={changePhoneAreacode}
                defaultValue={phoneAreaCode}
                style={{ marginLeft: '21.09px', width: 120, borderBottom: '1px solid #cfd2e3' }}
                allowClear>
                {props?.phoneAreaCodes.map((items: any) => (
                  <Option key={items} value={items}>
                    {items}
                  </Option>
                ))}
              </Select>
              <Form.Item label=" " name={item.fieldCode} key={index}>
                <InputReset
                  type={item.contentType}
                  inputValue={form.getFieldValue(`${item.fieldCode}`)}
                  placeholder={props.defaultLang === 'EN' ? item.fieldEnName : item.fieldLocalName}
                  remark={item.fieldEnPlaceholder}
                />
              </Form.Item>
            </Space>
          )}
          {item.componentType === ComponentEnum.INPUT && item.contentType === ComponentEnum.FILE && (
            <Form.Item
              label=" "
              name={item.fieldCode}
              key={index}
              rules={[
                {
                  required: item.required,
                },
              ]}>
              <Upload
                inputValue={form.getFieldValue(`${item.fieldCode}`)}
                placeholder={props.defaultLang === 'EN' ? item.fieldEnName : item.fieldLocalName}
                remark={item.fieldEnPlaceholder}
              />
            </Form.Item>
          )}
        </>
      )),
    }));
  }, [stepsData]);

  const next = async () => {
    props.getParams(form.getFieldsValue());
    if (current < dynamicSteps.length - 1) {
      try {
        await form.validateFields();
        setCurrent(current + 1);
        setFormShow(false);
        setFormShow(true);
      } catch (error) {
        console.log(error);
      }
    } else {
      const input1 = document.getElementById('input1') as any;
      const input2 = document.getElementById('input2') as any;
      if (!input1.checked) {
        message.error('Please check the agreement and submit');
        return false;
      }
      if (!input2.checked) {
        message.error('Please check permission and submit');
        return false;
      }
      try {
        const data = Object.assign({}, props.paramsData, form.getFieldsValue());
        await formStore.createCompany({ context: data });
        history.push('/form-submit/success');
      } catch (e) {
        message.error((e as AxiosError).message);
      }
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };
  const saveToEmail = () => {
    setIsModalVisible(true);
  };

  const changeEmail = (e: any) => {
    setEmail(e.target.value);
  };

  const submitToEmail = async () => {
    props.changeLoading(true);
    const params = {
      email: email,
      stepId: stepsData[current].stepId,
      mobile: {
        phoneAreaCode: PhoneCode,
        phoneNumber: form.getFieldValue('PhoneNumber'),
      },
      context: form.getFieldsValue(),
    };
    try {
      const {
        data: { code },
      } = await formStore.draft(params);
      message.success(code);
      setIsModalVisible(false);
    } catch (e) {
      message.error((e as AxiosError).message);
    } finally {
      props.changeLoading(false);
    }
  };

  return (
    <>
      {formShow && (
        <Form form={form}>
          <Wrapper>
            <Steps current={current}>
              {dynamicSteps.map((item: any) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
            <div className="steps-content">{dynamicSteps[current]?.content}</div>
            {current === dynamicSteps.length - 1 && (
              <div
                className="contract"
                dangerouslySetInnerHTML={{
                  __html:
                    props.defaultLang === 'EN' ? props.contract?.elementEnScript : props.contract?.elementLocalScript,
                }}></div>
            )}
            <div className="steps-action">
              <Space>
                {current > 0 && (
                  <button
                    className={`save-to-email ${current === 0 ? 'button-style' : 'button-default'}`}
                    onClick={() => prev()}>
                    Previous
                  </button>
                )}
                {current <= dynamicSteps.length - 1 && (
                  <button
                    onClick={saveToEmail}
                    className={`save-to-email ${current === 0 ? 'button-style' : 'button-default'}`}>
                    Save to Email
                  </button>
                )}
                {
                  <button
                    className={`next ${current === 0 ? 'button-style' : 'button-default'}`}
                    //disabled={current === steps.length - 1}
                    onClick={() => next()}>
                    {current === dynamicSteps.length - 1 ? 'Submit' : 'Next'}
                  </button>
                }
              </Space>
            </div>
            <Modal
              getContainer={false}
              closable={false}
              onCancel={() => setIsModalVisible(false)}
              className="modal"
              footer={
                <div>
                  <button className="saveEmail" onClick={submitToEmail}>
                    Save to Email
                  </button>
                </div>
              }
              visible={isModalVisible}>
              <div style={{ width: '320px', borderRadius: '10px' }}>
                <h2 className="title">The filled information is temporarily saved to the mailbox</h2>
                <input
                  onChange={changeEmail}
                  style={{
                    width: '100%',
                    border: 'none',
                    marginTop: '10px',
                    borderBottom: '1px solid #ccc',
                    outline: 'none',
                    margin: 'none',
                  }}
                  placeholder="Email"
                />
              </div>
            </Modal>
          </Wrapper>
        </Form>
      )}
    </>
  );
};

const Wrapper = styled.div`
  position: relative;
  padding: 0 30px;
  .contract {
    margin-top: 20px;
    input {
      margin-right: 10px;
    }
  }
  .steps-action {
    margin: 30px 0 15px;
    button {
      height: 34px;
      color: #141c30;
      font-size: 14px;
      border-radius: 4px;
      font-weight: bold;
      cursor: pointer;
    }
    .next {
      border: none;
      background-color: #f6ff7e;
    }
    .save-to-email {
      border: 1px solid #eaeaea;
      background-color: #fff;
    }
    .button-style {
      width: 22.5vw;
    }
    .button-default {
      width: 15vw;
    }
  }
  .ant-modal-content {
    width: 370px;
    border-radius: 10px;
  }
  .ant-modal-footer {
    position: relative;
    top: -12px;
    border-top: none;
  }
  .title {
    margin-bottom: 0;
    font-size: 16px;
  }
  .saveEmail {
    background: #f6ff7e;
    width: 140px;
    height: 34px;
    color: #141c30;
    border: none;
  }

  .phone {
    /* display: flex;
    justify-content: flex-start; */
  }

  .upload {
    .upload-area {
      h2 {
        margin-top: 30px;
        font-size: 14px;
        color: #141c30;
      }
      p {
        font-size: 12px;
        color: #b7bacb;
      }
      .Auth-letter {
        font-size: 12px;
        color: #2247ff;
        margin-bottom: 8px;
        cursor: pointer;
      }
    }
  }

  .ant-steps {
    margin-top: 20px;
  }
  .ant-steps-item-icon {
    width: 10px;
    height: 10px;
    top: 14px;
    left: 30px;
    .ant-steps-icon {
      top: 3px;
    }
  }
  .ant-form-item {
    margin-bottom: 0 !important;
  }

  .ant-steps-item-title {
    font-size: 14px;
    padding: none;
    padding-right: 0 !important;
    line-height: none;
    left: -8px;
    top: -11px;
  }
  .ant-steps-item-title::after {
    top: 32px;
  }
  .ant-steps-icon {
    display: none;
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: #000;
  }
  .ant-steps-item-process .ant-steps-item-icon {
    background: #000;
    border-color: #000;
  }
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
    background-color: #000;
  }
  .ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
    padding-left: 0px;
  }
  .ant-upload.ant-upload-select-picture-card {
    border: 1px solid #f6f6f6;
  }

  .ant-form-horizontal .ant-form-item-label {
    display: block;
    width: 21.09px !important;
  }
  .ant-form-item-label > label {
    width: 21.09px !important;
  }

  .agreement {
    display: flex;
    margin-top: 10px;
    font-size: 12px;
    color: #3e4459;
    align-items: center;
    input {
      display: block;

      margin-right: 10px;
    }
  }

  .Cascader {
    width: 100%;
    height: 44px;
    margin: 20px auto 0 !important;
    color: #141c30 !important;
    font-size: 14px;
    border-bottom: 1px solid #cfd2e3;
  }
  .ant-form-item-has-error .ant-input:focus,
  .ant-form-item-has-error .ant-input-affix-wrapper:focus,
  .ant-form-item-has-error .ant-input-focused,
  .ant-form-item-has-error .ant-input-affix-wrapper-focused {
    -webkit-box-shadow: none !important;
  }
  .ant-form-item-has-error .ant-input:not(.ant-form-item-has-error .ant-input-disabled) {
    background: transparent !important;
  }
  .ant-form-item-label > label {
    position: relative !important;
    top: 30px !important;
  }
  .ant-form-item-label > label::after {
    content: '' !important;
  }
  @media only screen and (max-width: 1000px) {
    .button-style {
      width: 37vw !important;
      font-size: 12px !important;
    }
    .button-default {
      width: 24vw !important;
      font-size: 12px !important;
    }
  }
`;

export default FormSteps;
